// removed by extract-text-webpack-plugin
module.exports = {"negative":"Storage_negative--1dji0"};


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/components/Storage/Storage.scss
// module id = 2172
// module chunks = 11